import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import $ from 'jquery';

import { startRecordingIfSamplingRequest } from 'js/fullstory';

import Portfolio from 'js/portfolio';
import * as reducers from 'js/portfolio/reducers/index';
import registerForRails from 'js/utils/registerForRails';
import StoreBuilder from 'js/utils/store_builder';
import 'js/utils/$a_global';

import { startActivityTracking } from 'js/core_webpack/metrics/page_activity_tracking';
startActivityTracking();

// Some files in portfolio use $ globally.
window.$ = $;
/**
 *   viewModes available:
 *   0 - premium (active portfolio)
 *   1 - premium (not active portfolio, not completed funnel) | short-funnel preview site (with link that creates
 *     your portfolio and takes you there
 *   2 - premiumable | short-funnel preview site (with links to upgrade page)
 *   3 - premiumable | long-funnel preview site (with links to upgrade page)
 *   4 - premium (not active portfolio, completed funnel) | long-funnel preview site (with link that creates
 *     your portfolio and takes you there
 */
registerForRails(
  {
    Portfolio: ({ store, serializedStore, ...props }) => {
      // do stuff with props and context from rails
      const storeData = store || serializedStore;
      const init = new StoreBuilder({ reducers, initialState: storeData });

      if (process.env.NODE_ENV === 'production') {
        // init external libraries
        startRecordingIfSamplingRequest(storeData.current_user);
      }

      return (
        <Provider store={init.store}>
          <BrowserRouter basename={props.basename}>
            <Portfolio {...props} />
          </BrowserRouter>
        </Provider>
      );
    },
  },
  ['js/portfolio'],
);
